import { TestResultDataType } from "../../Common/Testing/TestResultDataType";
import { BaseTestResultData } from "../../Common/Testing/BaseTestResultData";

export class StatementRuleTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.STATEMENT_RULE;
}
